import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import { NegociosService, MONEDA_DOLAR_ID, MONEDA_DOLAR_NAME, EntregaService, CommonService } from '@services/index';
import * as moment from 'moment';
import { MonedaService } from '@services/moneda-service';
import { PosicionService } from '@services/posicion-service';
import { SpinnerService } from '@services/spinner-service';
import { dateToUnixTime } from '@utils/index';
import {current} from "codelyzer/util/syntaxKind";

@Component({
  selector: 'entrega-dialog-component',
  templateUrl: './entrega-dialog.component.html',
  styleUrls: ['./entrega-dialog.component.scss']
})
export class EntregaDialogComponent implements AfterViewInit, OnInit {
  private currentMonth;
  private monthOptions;
  private yearOptions;
  private currentYear;
  private selectedMonth;
  private selectedYear;
  private posiciones;
  private submitted;
  private selectedDate: Date;
  public hiddenRows;

  private isPagoDiferido = false;
  private pagoDiferidoDate = null;
  private posicionError = null;

  private minDate = moment().startOf('day').toDate();
  private maxDate = moment().add(10, 'year').startOf('day').toDate();
  @ViewChild('diferidoDatePicker') diferidoDatePicker;
  @ViewChild('diferidoDateInput') diferidoInput;



  constructor(public dialogRef: MdDialogRef<EntregaDialogComponent>,
    private posicionService: PosicionService,
    private spinnerService: SpinnerService
  ) {
    this.monthOptions = posicionService.MonthOptions;
    this.yearOptions = posicionService.YearOptions;
    posicionService.Options.subscribe(value => {
      this.posiciones = value;
    });
  }


  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    let tmpDate = new Date();
    this.currentMonth = tmpDate.getMonth();
    this.currentYear = tmpDate.getFullYear();
    this.selectedYear = this.currentYear;
    this.selectedMonth = this.monthOptions.find(x => x.Value === this.currentMonth);
  }

  get posicionTitle() {
    return this.selectedMonth.ShortName + "-" + this.selectedYear.toString().substr(2, 2);
  }

  isDisabledMonth(e) {
    if (this.selectedYear > this.currentYear) return false;
    if (e.Value < this.currentMonth) return true;
    return false;
  }

  get isValid() {
    if (!this.isPagoDiferido) {
      this.selectedDate = new Date(this.selectedYear, this.selectedMonth.Value, 1);
      const time = this.selectedDate.getTime();
      const exist = this.posiciones.find(element => {
        return element.Ent_Id === 3 && time === element.Time;
      });
      return exist === undefined;
    } else {
      if (this.pagoDiferidoDate !== null) {
        const currentDate = this.pagoDiferidoDate.getTime();
        const exist = this.posiciones.find(element => {
          return element.Ent_Id === 4 && currentDate === element.Time;
        });
        return exist === undefined;
      } else {
        return true;
      }
    }
  }

  // verificar si el valor ingresado en realidad está oculto
  isHidden() {
    if (!this.isPagoDiferido) {
      this.selectedDate = new Date(this.selectedYear, this.selectedMonth.Value, 1);
      const time = this.selectedDate.getTime();
      // si encuentra un elemento, retorna el elemento, si no retorna false
      for (let i = 0; i < this.hiddenRows.length; i++) {
        if (this.hiddenRows[i].PosFecha === time) {
          return this.hiddenRows[i];
        }
      }
    } else {
      const currentDateString = moment(this.pagoDiferidoDate).startOf('day').valueOf();
      for (let i = 0; i < this.hiddenRows.length; i++) {
        if (moment(this.hiddenRows[i].PosString, 'DD-MM-YYYY').startOf('day').valueOf() === currentDateString) {
          return this.hiddenRows[i];
        }
      }
    }
    return false;
  }

  onSubmit() {
    const isHidden = this.isHidden();
    // si esHidden es falso (no esta escondido, es un nuevo valor) continuar, si no retornar el valor escondido
    if (isHidden === false) {
      const entId = this.isPagoDiferido ? 4 : 3;
      const posicionName = this.isPagoDiferido ? moment(this.pagoDiferidoDate).format('DD/MM/YYYY') :
        this.selectedMonth.Name.toString().toLowerCase() + '-' + this.selectedYear.toString().substr(2, 2);
      if (this.isValid) {
        this.spinnerService.setShowFlag(true);
        const posicion = {
          Posicion: posicionName,
          Fecha: this.isPagoDiferido ? dateToUnixTime(this.pagoDiferidoDate) : dateToUnixTime(this.selectedDate),
          Ent_ID: entId
        };
        this.posicionService.saveNew(posicion).subscribe(response => {
          if (response.StatusCode === 200) {
            this.posicionService.loadOptions();
            this.closeDialog();
          }
          this.spinnerService.setShowFlag(false);
        }, err => this.spinnerService.setShowFlag(false));
      }
    } else {
      this.closeReturnHidden(isHidden);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // si el item a crear en realidad estaba oculto, mostrarlo
  closeReturnHidden(item) {
    const row = [{
      Id: item.Id,
      Moneda: item.Moneda,
      Fecha: item.PosFecha / 1000,
      Hidden: false
    }];

    this.posicionService.updateRows(row)
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });
  }

  onTypeChange(e) {
    if (e === 'posicion' && this.isPagoDiferido) {
      this.isPagoDiferido = false;
      this.pagoDiferidoDate = null;
      // this.diferidoInput.
    } else if(e === 'diferido' && !this.isPagoDiferido) {
      this.isPagoDiferido = true;
    }
  }

  openPagoDiferidoPicker() {
    this.diferidoDatePicker.open();
  }

  onPagoDiferidoSelected(e) {
    this.pagoDiferidoDate = moment(e).startOf('day').toDate();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/new-precio/entrega-dialog.component.ts